import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'

import type { FC } from 'react'

interface PageGuardTimPenilaiProps {
  children: React.ReactNode
  type: 'TK' | 'PPK'
}

const PageGuardTimPenilai: FC<PageGuardTimPenilaiProps> = ({
  children,
  type,
}) => {
  const {
    isPPKPengawasSekolah,
    isTimKinerjaPengawasSekolah,
    isLoading,
    leave,
  } = useRoleContext()

  if (!isLoading) {
    // If the user is not a Tim Kinerja Pengawas Sekolah or PPK Pengawas Sekolah, leave the page
    if (!isTimKinerjaPengawasSekolah && !isPPKPengawasSekolah) {
      leave()
    }

    if (type === 'TK' && !isTimKinerjaPengawasSekolah) {
      // If we expect the user to be a TK but they are not, leave the page
      leave()
    } else if (type === 'PPK' && !isPPKPengawasSekolah) {
      // If we expect the user to be a PPK but they are not, leave the page
      leave()
    }
  }

  // As the component should not be rendered when still loading the user role, we can just return null
  if (isLoading) return null

  return <>{children}</>
}

export default PageGuardTimPenilai
